import type { LibraryWork } from '../../../../../interfaces/work';

const savedAtFormatter = new Intl.DateTimeFormat(undefined, {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});

export const formatSavedAtLabel = (savedAt?: string): string | undefined => {
  if (!savedAt) return undefined;
  const date = new Date(savedAt);
  if (Number.isNaN(date.valueOf())) return undefined;

  try {
    return `Saved ${savedAtFormatter.format(date)}`;
  } catch (_error) {
    return `Saved ${date.toISOString().split('T')[0]}`;
  }
};

export const formatWorkSavedAtLabel = formatSavedAtLabel;

export const resolveWorkImageUrl = (
  work: LibraryWork,
  composerImages: ReadonlyMap<string, string>
): string | undefined => {
  const explicitImage =
    typeof work.imageUrl === 'string' && work.imageUrl.trim().length ? work.imageUrl : undefined;
  if (explicitImage) return explicitImage;

  const composerKeys: string[] = [];
  if (typeof work.composerId === 'string' && work.composerId.trim().length) {
    composerKeys.push(work.composerId.trim());
  }

  for (const key of composerKeys) {
    const candidate = composerImages.get(key);
    if (typeof candidate === 'string' && candidate.trim().length) {
      return candidate;
    }
  }

  return undefined;
};
